/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { useShowError } from "~/components/Error/useShowError";
import { RouteParams } from "~/models";
import { useAxios } from "~/tools";

const useProducts = () => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [products, setProducts] = React.useState([]);
  const { customerId } = useParams<RouteParams>();
  const { Axios } = useAxios();
  const { showError } = useShowError();

  const fetchProducts = React.useCallback(async () => {
    try {
      const { data } = await Axios().get(`/customers/${customerId}/products`);
      setProducts(data?.attachedProducts);
    } catch (e) {
      showError(e.response);
    } finally {
      setIsLoading(false);
    }
  }, [Axios, customerId, showError]);

  React.useEffect(() => {
    fetchProducts();
  }, [fetchProducts, customerId]);

  return { products, isLoading, fetchProducts };
};

export { useProducts };
